import React from 'react';
import PropTypes from 'prop-types';

import { TypeGroupComponent }  from './TypeGroupComponent.js';

const sensorPortRegex = /sensor\/([^\/]+)\/([^\/]+)\/(\d+)/;
const groupTypeRegex = /group\/([^\/]+)/;


export class GroupingIdMixin extends React.Component {
    state = {
        idPath: null,
        idPathSub: null,
        types: {},
        tsTypesChanged: 0,
        error: null,
        loading: true,
    };

    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired
    }

    // static childContextTypes = {
    //     groupName: PropTypes.string,
    // }

    // getChildContext() {
    //     return {
    //         groupName: groupName
    //     };
    // }

    unsubscribeAll = () => {
        if (this.state.idPathSub) {
            this.context.p.unsubscribeDS(this.idPathSubChanged, this.state.idPathSub);
        }
    }

    subscribe(idPath) {
        this.unsubscribeAll();
        let idPathSub = this.context.p.subscribeDS(idPath, this.idPathSubChanged);

        this.setState({subscriptions: [], idPathSub: idPathSub, idPath: idPath, loading: true});

        this.idPathSubChanged(this.context.p.getPath(idPath));
    }

    idPathSubChanged = (value, p1, p2) => {
        const idSubPath = this.props.idSubPath;

        console.log("changed", value, p1, p2);
        if (value === 0 || value === null || value === undefined) {
            this.setState({error: "notfound"});
            return;
        }
        if (!value[idSubPath]) {
            return;
        }

        const paths = value[idSubPath].concat(this.props.addPaths ? this.props.addPaths : []);

        // Because maps preserve insertion order we can sort the path set
        // before exploding and will have sorted ports
        paths.sort();

        // Explode all paths and pack them in one bin
        let rootBin = {};
        let types = {};

        function addType(type, path) {
            if (types[type] === undefined) {
                types[type] = [];
            }
            types[type].push(path);
        }

        for (let i in paths) {
            const path = paths[i];

            let matches;
            if ((matches = sensorPortRegex.exec(path))) {
                addType(matches[2], path);
            } else if ((matches = groupTypeRegex.exec(path))) {
                // For groups, the type is not in the path but in the topic
                const type = this.context.p.getPath(path)?.type;
                if (type) {
                    addType(type, path);
                }
            }
        }

        this.setState((state) => {
            return { types: types, tsTypesChanged: state.tsTypesChanged + 1 };
        });
    }

    subChanged = () => {

    }

    shouldComponentUpdate(nextProps, nextState) {
        // console.log("GroupingIdMixin shouldComponentUpdate", nextProps, this.props.idPath !== this.state.idPath, nextState?.tsTypesChanged != this.state.tsTypesChanged, nextState?.tsTypesChanged, this.state.tsTypesChanged);
        return (this.props.idPath !== this.state.idPath || nextState?.tsTypesChanged != this.state.tsTypesChanged || this.props.isCreatingReport !== nextProps.isCreatingReport || this.props.reportSerial !== nextProps.reportSerial);
    }

    componentDidUpdate(prevProps) {
        // console.log("GroupingIdMixin componentDidUpdate", prevProps.idPath, this.props.idPath);
        if (this.props.idPath !== this.state.idPath) {
            this.subscribe(this.props.idPath);
        }
    }

    componentDidMount() {
        if (this.props.idPath !== this.state.idPath) {
            this.subscribe(this.props.idPath);
        }
    }

    render() {
        let orderedGroups = [];
        for (let typeId in this.state.types) {
            const group = (
                <TypeGroupComponent {...this.props} key={typeId + "-" + this.state.types[typeId].join("-")} typeId={typeId} paths={this.state.types[typeId]} />
            );
            orderedGroups.push(group);
        }


        return orderedGroups;
    }

    componentWillUnmount() {
        console.log("GroupingIdMixin componentWillUnmount");
        this.unsubscribeAll();
    }
};

GroupingIdMixin.propTypes = {
    idPath: PropTypes.string.isRequired,
    idSubPath: PropTypes.string.isRequired,
    subscribeSensor: PropTypes.func.isRequired,
    pushCB: PropTypes.func.isRequired,
    pushComponentCB: PropTypes.func.isRequired,
    addPaths: PropTypes.array,
    resultPath: PropTypes.string,
    isCreatingReport: PropTypes.bool.isRequired,
    changeReportTopic: PropTypes.func.isRequired,
    reportTopics: PropTypes.array,
    reportSerial: PropTypes.number,
    showThresholdPopup: PropTypes.func.isRequired
};
